/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getBrand } from '../../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

const styles = {
    loaderIcon: {
        margin: '250px auto',
        width: '66px',
        height: '66px',
        backgroundImage: 'url(https://cdn1.cheryls.com/wcsstore/CherylAndCompany/images/ajax-loader-large.gif)',
        borderRadius: '100%',
    },
    ModalBox: {
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: '3500',
    },
    bottomSpinner: {
        color: '#fff',
    },
    spinner: {
        position: 'fixed',
        top: '35%',
        left: '46%',
        zIndex: '10001',
    },
};

const SiteLoader = ({ classes }) => {
    const brand = useSelector(getBrand);

    return (
        <Modal
            BackdropProps={{
                classes: {
                    root: classes.ModalBox,
                },
            }}
            open
        >
            {brand?.code === 'PLA' ? (
                <>
                    <CircularProgress
                        variant="determinate"
                        className={classes.bottomSpinner}
                        classes={{ root: classes.spinner }}
                        thickness={5}
                        size={70}
                        value={100}
                    />
                    <CircularProgress
                        size={70}
                        classes={{ root: classes.spinner }}
                        thickness={5}
                    />
                </>
            ) : (
                <div className={classes.loaderIcon} />
            )}
        </Modal>
    );
};

SiteLoader.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SiteLoader);
